import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import DAProtect from '@wix/da-ds/pkg/Icons/24x24/DAProtect';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { URLS } from '@wix/da-url';
import SophisticatedTooltip from '../Popover/Preset/SophisticatedTooltip';
import s from './DAProtectIconWithTooltip.scss';
var DAProtectIconWithTooltip = function (_a) {
    var variant = _a.variant, _b = _a.withLabel, withLabel = _b === void 0 ? false : _b, rest = __rest(_a, ["variant", "withLabel"]);
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(SophisticatedTooltip, { size: "medium", "aria-label": t("daProtect.tooltip.ariaLabel"), description: t("daProtect.tooltip.var." + variant), hasCloseButton: false, width: isMobile ? 200 : 380, postfix: variant !== 'active' && (React.createElement(SophisticatedTooltipLink, { href: URLS.CORE_MEMBERSHIP, biData: {
                evid: BiEventType.BUY_CORE_BUTTON,
                referral_info: variant === 'inactive'
                    ? ReferralType.DAPROTECT_OFF
                    : ReferralType.DAPROTECT_TEMP,
            } }, t('daProtect.tooltip.upgrade'))) },
        React.createElement("div", { className: s['icon'] },
            React.createElement(DAProtect, __assign({ disableDefaultColors: true, variant: variant }, rest)),
            withLabel && (React.createElement("span", { className: s['label'] },
                isMobile && t("daProtect.label.mobile.var." + variant),
                !isMobile && t("daProtect.label.desktop.var." + variant))))));
};
DAProtectIconWithTooltip.displayName = 'DAProtectIconWithTooltip';
export default DAProtectIconWithTooltip;
//# sourceMappingURL=DAProtectIconWithTooltip.js.map